import type { BlokFetcherProps, BlokProps } from "@trydig/storyblok";
import { rpc } from "#rpc";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { ExplorationProduct } from "@/components/ui/sections/ExplorationProduct";
import type { ProductsRoute } from "@/data/routes/products.route";
import type { ExplorationProductStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

const clampLimit = (raw: string | number | undefined) => {
	const n = typeof raw === "number" ? raw : Number(raw ?? 4);
	if (!Number.isFinite(n) || n < 1) return 4;
	return Math.min(12, Math.floor(n));
};

export const explorationProductFetcher = async ({
	blok,
}: BlokFetcherProps<ExplorationProductStoryblok>) => {
	return rpc.products.exploration({
		ids: blok.products,
		categoryId: blok.centraCategory,
		limit: clampLimit(blok.productLimit),
	});
};

export const explorationProductKey = ({ blok }: BlokFetcherProps<ExplorationProductStoryblok>) => [
	...(blok.products ?? []),
	blok.centraCategory ?? "",
	String(blok.productLimit ?? 4),
];

export const ExplorationProductBlok = ({
	blok,
	data,
}: BlokProps<ExplorationProductStoryblok, ProductsRoute["exploration"]>) => {
	const bg = checkBlokBackground(blok);
	const linkHref = sbLink(blok.link)?.href;

	return (
		<BlokWrap editable={blok} asChild>
			<ExplorationProduct
				heading={blok.heading || undefined}
				linkLabel={blok.linkLabel || undefined}
				linkHref={linkHref}
				products={data?.products ?? []}
				bg={bg}
			/>
		</BlokWrap>
	);
};
